export default {
  ch: 'ltr',
  en: 'ltr',
  fa: 'rtl',
};
